import Box from '@mui/material/Box';

import CaseStudyCard from '@/components/Footer/BrandCard/CaseStudyCard';

import styles from './CaseStudyShowcase.module.scss';

export interface ShowcaseItem {
  slug: string;
  title: string;
  imageSrc: string;
  imageAlt: string;
  accentColor: 'orange' | 'blue' | 'cyan' | 'graphite';
}

interface CaseStudyShowcaseProps {
  items: ShowcaseItem[];
}

type CardPosition = 1 | 2 | 3 | 4;

const POSITIONS: CardPosition[] = [1, 2, 3, 4];

const CaseStudyShowcase = ({ items }: CaseStudyShowcaseProps) => {
  const cards = items.slice(0, 4);

  return (
    <Box className={styles.showcase}>
      <Box className={styles.stack}>
        {cards.map((item, index) => (
          <CaseStudyCard
            key={item.slug}
            slug={item.slug}
            title={item.title}
            imageSrc={item.imageSrc}
            imageAlt={item.imageAlt}
            accentColor={item.accentColor}
            position={POSITIONS[index]}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CaseStudyShowcase;
